import { render, staticRenderFns } from "./A4.vue?vue&type=template&id=c2f32f78&"
import script from "./A4.vue?vue&type=script&lang=ts&"
export * from "./A4.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports